import * as React from 'react';
import { ApplicationStore } from '../../data_layer/stores/ApplicationStore';
import { computed } from 'mobx';
import { PageContainerStyle, PageStyle } from '../../assets/styles/Page';
import Dialog, { DialogTitle, DialogContent, DialogContentText, DialogActions } from 'material-ui/Dialog/index';
import Button from 'material-ui/Button';

interface Props {
    store?: ApplicationStore;
}

interface State {
    errorModalOpen?: boolean;
}

const DEFAULT_ERR: string = 'Unknown error, please reload the page.';

export abstract class Page<P, S> extends React.Component<Props & P, S & State> {
    private errorMessage?: string;

    protected abstract renderPage(): React.ReactNode;

    protected showError(error?: Error | string) {
        
        if (typeof error === 'string') {
            this.errorMessage = error || DEFAULT_ERR;
        } else if (typeof error === 'object') {
            this.errorMessage = error.message || DEFAULT_ERR;
        } else {
            this.errorMessage = DEFAULT_ERR;
        }
        
        this.setState({ errorModalOpen: true });
    }
    
    private closeErrorModal() {
        this.setState({
            errorModalOpen: false,
        });
    }

    @computed
    protected get canShowData(): boolean {
        return this.props.store && false === this.props.store.isUpdating && this.props.store.storeIsReady;
    }

    render() {
        if (this.canShowData) {
            return (
                <div style={PageStyle}>
                    <Dialog
                        title={'Error'}
                        open={(this.state && this.state.errorModalOpen) ? true : false}
                        onClose={() => { this.closeErrorModal() }}
                    >
                        <DialogTitle>
                            Error
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {this.errorMessage}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    this.closeErrorModal() ;
                                }}
                                variant={'raised'}
                            >
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <div style={PageContainerStyle}>
                        {this.props.store && this.props.store.storeIsReady && this.renderPage()}
                    </div>
                </div>
            );
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/Page.tsx